import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import {useNavigate} from "react-router";

const ErrorPage404 = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      px={2}>
      <Card sx={{maxWidth: 500, textAlign: "center", p: 3}}>
        <CardContent>
          <Typography variant="h1" color="textDisabled" fontWeight="bold">
            404
          </Typography>
          <Typography
            variant="h5"
            color="textPrimary"
            sx={{mt: 1, fontWeight: "bold"}}>
            The page you're looking for could not be found.
          </Typography>
          <Divider sx={{my: 3}} />
          <Typography variant="body1" color="textSecondary">
            The page you're looking for might have been moved, deleted, or
            renamed.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{mt: 1}}>
            If you think this is a mistake,{" "}
            <a href="devs@afrigaming.net">report a broken link</a>.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(-1)}
            sx={{mt: 3}}>
            Go Back
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ErrorPage404;
